let currentSlideGrid = 0;
let prev = document.querySelector(".prev-slide");
let next = document.querySelector(".next-slide");


function showSlide(index) {
  const slides = document.querySelector(".announcment-bar__slider");

  if (!slides) {
    return;
  }

  currentSlideGrid =
    (index + slides.childElementCount) % slides.childElementCount;
  const translateValue = -currentSlideGrid * 100 + "%";
  slides.style.transform = "translateX(" + translateValue + ")";
}

function changeSlide(event, direction) {
  event.preventDefault();
  showSlide(currentSlideGrid + direction);
}

function changeSlideAuto(direction) {
  showSlide(currentSlideGrid + direction);
}

document.addEventListener("DOMContentLoaded", () => {
  showSlide(0);
});


setInterval(function() {
  changeSlideAuto(1);
}, 10000);

// video part

const videoFullWrapper = document.getElementById('video-with-previw-mode_full-desktop');
const videoFullDektop = document.getElementById('video-with-previev-wrapper__desktop-full');
const videoFullMobile = document.getElementById('video-with-previev-wrapper__mobile-full');

function showVideo() {
  document.querySelector('.video-with-previw-mode_preview').style.display = 'none';
  videoFullWrapper.style.display = 'block';
  videoFullDektop.play();
}

function showVideo2() {
  document.querySelector('.video-with-previw-mode_preview').style.display = 'none';
  videoFullWrapper.style.display = 'block';
  videoFullMobile.play()
}

document.addEventListener("DOMContentLoaded", function() {
  function checkAutoPlay() {
    var mobileVideo = document.getElementById("video-with-previev-wrapper__mobile-preview");
    var desktopVideo = document.getElementById("video-with-previev-wrapper__desktop-preview");

    if (mobileVideo || desktopVideo) {
         if (window.matchMedia("(max-width: 767px)").matches) {
      mobileVideo.muted = true;
      mobileVideo.setAttribute('autoplay', "true");
      mobileVideo.play().catch(function(error) {
        console.error("Error playing mobile video:", error);
      });
    } else {
      desktopVideo.muted = true; // Добавляем эту строку для обхода политик автовоспроизведения
      desktopVideo.play().catch(function(error) {
        console.error("Error playing desktop video:", error);
      });
    } 
    }
  }

  checkAutoPlay();

  function checkAutoPlayMobile() {
    var mobileVideo = document.getElementById("video-with-previev-wrapper__mobile-preview");

    if (window.matchMedia("(max-width: 767px)").matches && navigator.userAgent.match(/(iPhone|iPod|iPad)/i) && mobileVideo) {
      mobileVideo.setAttribute('autoplay', "true");
    }
  }

  checkAutoPlayMobile()
});



document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".announcement-bar__all-width-text-wrapper");
  if (!wrapper) return;

  // Берём всё: p, a и мобильный блок
  let slides = Array.from(
    wrapper.querySelectorAll(":scope > p, :scope > a, :scope > .mobile-only-slide")
  );

  // Если мобильная версия — вставляем мобильный слайд первым
  const isMobile = () => window.innerWidth <= 768;

  if (isMobile()) {
    const mobileSlide = wrapper.querySelector(".mobile-only-slide");
    if (mobileSlide) {
      mobileSlide.style.display = "flex";
      wrapper.prepend(mobileSlide);
      slides = Array.from(
        wrapper.querySelectorAll(":scope > p, :scope > a, :scope > .mobile-only-slide")
      );
    }
  }

  // Добавляем класс .announcement-bar__slide
  slides.forEach(s => s.classList.add("announcement-bar__slide"));

  let current = 0;

  function showSlide(i) {
    slides.forEach(s => s.classList.remove("announcement-bar__slide--active"));
    slides[i].classList.add("announcement-bar__slide--active");
  }

  function nextSlide() {
    current = (current + 1) % slides.length;
    showSlide(current);
  }

  // Стартуем
  if (slides.length) {
    showSlide(current);
    setInterval(nextSlide, 4000);
  }
});